import * as React from "react";
import { forwardRef } from "react";
const Svg16Px = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M13.3332 8L12.3932 7.06L8.6665 10.78V2.66667H7.33317V10.78L3.61317 7.05334L2.6665 8L7.99984 13.3333L13.3332 8Z", fill: "currentColor" }));
const ForwardRef = forwardRef(Svg16Px);
export default ForwardRef;
